/**
 * Las constantes del cuadro de muelles.
 *
 * La jornada (06:00–20:00) la manda el BACKEND: el eje horario entero depende de
 * ella y no puede vivir en el cliente, donde cada pestaña abierta tendría su
 * versión. Lo de aquí es el valor de arranque mientras la petición vuelve, y las
 * medidas de dibujo, que sí son cosa de la pantalla.
 */

/** Jornada de arranque. El backend manda la de verdad en `CuadroMuelles`. */
export const JORNADA_INICIO = 6
export const JORNADA_FIN = 20

/** Granularidad a la que se redondea al pinchar un hueco del carril. */
export const SLOT_MINUTOS = 30

/** La zona en la que están los muelles. Sale en el pie de la pantalla, porque
 *  una hora sin zona en una pantalla de expedición no dice nada. */
export const ZONA = 'Europe/Madrid'

/** Ancho del panel fijo de la izquierda. Menos que el del Gantt de producción
 *  (280 px): ahí cabe el nombre de un artículo y aquí sólo el de un muelle. */
export const INFO_COL_DOCK = 200

export const GAP_CARRIL = 4
export const PAD_CARRIL = 10

/** A partir de cuántos camiones solapados se deja de abrir carriles y se resume
 *  en un chip «+N». */
export const CARRILES_MAX = 4

/**
 * Alto de una barra según cuántos carriles tenga que albergar su fila.
 *
 * Encoge a propósito. Un muelle con cuatro camiones solapados no puede convertir
 * su fila en cuatrocientos píxeles y empujar los otros tres muelles fuera de la
 * pantalla: el cuadro sirve para ver de un vistazo dónde hay hueco, y para eso
 * los muelles tienen que caber todos a la vez.
 */
export function altoBarra(carriles: number): number {
  if (carriles <= 1) return 84
  if (carriles === 2) return 40
  if (carriles === 3) return 28
  return 22
}

/** Alto total de la fila de un muelle, con sus márgenes y separaciones. */
export function altoFila(carriles: number): number {
  const n = Math.max(1, Math.min(carriles, CARRILES_MAX))
  return PAD_CARRIL * 2 + n * altoBarra(n) + (n - 1) * GAP_CARRIL
}

/** Desplazamiento vertical de una barra dentro de su fila. */
export function topCarril(carril: number, carriles: number): number {
  const n = Math.max(1, Math.min(carriles, CARRILES_MAX))
  return PAD_CARRIL + carril * (altoBarra(n) + GAP_CARRIL)
}
